/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Spaces_Inherited_Banner_Description_FilesInputs */



/**
* | output |
* | --- |
* | "You're not a member of this space. A project you belong to links {count} of its files, so those are all you can see here — the same access the AI uses to ans..." |
*
* @param {Spaces_Inherited_Banner_Description_FilesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_inherited_banner_description_files = /** @type {((inputs: Spaces_Inherited_Banner_Description_FilesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Inherited_Banner_Description_FilesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Du bist kein Mitglied dieses Spaces. Ein Projekt, dem du angehörst, hat ${i?.count} seiner Dateien verknüpft — nur diese siehst du hier, und genau mit diesem Zugriff antwortet die KI daraus. Nur lesend, und er endet mit der Verknüpfung oder deiner Projektmitgliedschaft.`)
	return /** @type {LocalizedString} */ (`You're not a member of this space. A project you belong to links ${i?.count} of its files, so those are all you can see here — the same access the AI uses to answer from them. Read-only, and it ends when the link or your project membership does.`)
});